import { EmployerFormFields, EmployerStatementRequest } from 'src/@types';
import { currencyToNumber, stringToBoolean } from '../../../../../utils';
import { employerStatementFormFields } from '../config';
import { convertDateString } from '../../../../../utils/dates';

const prepareFormData = ({
  employerName,
  employerAddress,
  employerPostCode,
  employerPlace,
  werkgeverskvk,
  // werknemersaanspreekvorm,
  werknemersnaam,
  werknemersadres,
  werknemerspostcode,
  werknemerswoonplaats,
  werknemersgeboortedatum,
  werknemersindiensttreding,
  werknemersfunctie,
  werknemersarbeidsvorm,
  werknemersuitdiensttreding,
  werknemersflexibelarbeidsvorm,
  heeftproeftijd,
  proeftijdverstreken,
  dienstverbandbinnenkortbeeindigen,
  toelichtingDienstverbandBeeindiging,
  isDirecteurAandeelhouder,
  percentageAandelen,
  verklaringVoortzettingDienstverband,
  jaBepaaldeTijd,
  wordenDeArbeidsvoorwaardenGewijzigd,
  toelichtingwordenDeArbeidsvoorwaardenGewijzigd,
  verklaringvoortzettingdienstverbandnaam,
  jaarsalaris,
  vakantieToeslag,
  onregelmatigheidsToeslag,
  vaste13eMaand,
  provisie,
  eindejaarsUitkering,
  overwerk,
  extraFlexibleBudget,
  incomeCustom1Title,
  incomeCustom1Amount,
  incomeCustom2Title,
  incomeCustom2Amount,
  heeftOnderhandseLening,
  ingangsdatumOnderhandseLening,
  hoofdsomOnderhandseLening,
  jaarlastOnderhandseLening,
  looptijdOnderhandseLening,
  heeftLoonbeslag,
  einddatumLoonbeslag,
  maandlastPerMaandLoonbeslag,
  naamOndertekenaar,
  getekendTe,
  datumOndertekening,
  naamContactpersoon,
  telefoonnummerContactpersoon
}: EmployerFormFields): EmployerStatementRequest => {
  return {
    werkgeversnaam: employerName,
    werkgeversadres: employerAddress,
    werkgeverspostcode: employerPostCode,
    werkgeversplaats: employerPlace,
    werkgeverskvk: werkgeverskvk,
    //werknemersaanspreekvorm: werknemersaanspreekvorm,
    werknemersnaam: werknemersnaam,
    werknemersadres: werknemersadres,
    werknemerspostcode: werknemerspostcode,
    werknemerswoonplaats: werknemerswoonplaats,
    werknemersgeboortedatum: convertDateString(werknemersgeboortedatum),
    werknemersindiensttreding: convertDateString(werknemersindiensttreding),
    werknemersfunctie: werknemersfunctie,
    werknemersarbeidsvorm: werknemersarbeidsvorm,
    werknemersuitdiensttreding: convertDateString(werknemersuitdiensttreding),
    werknemersflexibelarbeidsvorm: werknemersflexibelarbeidsvorm,
    heeftProeftijd: stringToBoolean(heeftproeftijd),
    proeftijdVerstreken: stringToBoolean(proeftijdverstreken),
    wordDienstverbandBinnenkortBeeindigd: stringToBoolean(dienstverbandbinnenkortbeeindigen),
    toelichtingDienstverbandBeeindiging: toelichtingDienstverbandBeeindiging,
    isDirecteurAandeelhouder: stringToBoolean(isDirecteurAandeelhouder),
    percentageAandelen: percentageAandelen,
    verklaringVoortzettingDienstverband: verklaringVoortzettingDienstverband,
    jaBepaaldeTijdMaanden: jaBepaaldeTijd,
    wordenDeArbeidsvoorwaardenGewijzigd: stringToBoolean(wordenDeArbeidsvoorwaardenGewijzigd),
    toelichtingwordenDeArbeidsvoorwaardenGewijzigd: toelichtingwordenDeArbeidsvoorwaardenGewijzigd,
    verklaringVoortzettingDienstverbandNaam: verklaringvoortzettingdienstverbandnaam,
    jaarsalaris: currencyToNumber(jaarsalaris),
    vakantieToeslag: currencyToNumber(vakantieToeslag),
    onregelmatigheidsToeslag: currencyToNumber(onregelmatigheidsToeslag),
    vaste13eMaand: currencyToNumber(vaste13eMaand),
    provisie: currencyToNumber(provisie),
    eindejaarsUitkering: currencyToNumber(eindejaarsUitkering),
    overwerk: currencyToNumber(overwerk),
    extraFlexibleBudget: currencyToNumber(extraFlexibleBudget),
    incomeCustom1Title: incomeCustom1Title,
    incomeCustom1Amount: currencyToNumber(incomeCustom1Amount),
    incomeCustom2Title: incomeCustom2Title,
    incomeCustom2Amount: currencyToNumber(incomeCustom2Amount),
    heeftOnderhandseLening: stringToBoolean(heeftOnderhandseLening),
    ingangsdatumOnderhandseLening: convertDateString(ingangsdatumOnderhandseLening),
    hoofdsomOnderhandseLening: currencyToNumber(hoofdsomOnderhandseLening),
    jaarlastOnderhandseLening: currencyToNumber(jaarlastOnderhandseLening),
    looptijdOnderhandseLening: looptijdOnderhandseLening,
    heeftLoonbeslag: stringToBoolean(heeftLoonbeslag),
    einddatumLoonbeslag: convertDateString(einddatumLoonbeslag),
    maandlastPerMaandLoonbeslag: currencyToNumber(maandlastPerMaandLoonbeslag),
    naamOndertekenaar: naamOndertekenaar,
    getekendTe: getekendTe,
    datumOndertekening: convertDateString(datumOndertekening),
    naamContactpersoon: naamContactpersoon,
    telefoonnummerContactpersoon: telefoonnummerContactpersoon
  };
};

const getDefaultValues = (): EmployerFormFields => {
  return {
    employerName: employerStatementFormFields.employerName.defaultValue,
    employerAddress: employerStatementFormFields.employerAddress.defaultValue,
    employerPostCode: employerStatementFormFields.employerPostCode.defaultValue,
    employerPlace: employerStatementFormFields.employerPlace.defaultValue,
    werkgeverskvk: employerStatementFormFields.werkgeverskvk.defaultValue,
    // werknemersaanspreekvorm: employerStatementFormFields.werknemersaanspreekvorm.defaultValue,
    werknemersnaam: employerStatementFormFields.werknemersnaam.defaultValue,
    werknemersadres: employerStatementFormFields.werknemersadres.defaultValue,
    werknemerspostcode: employerStatementFormFields.werknemerspostcode.defaultValue,
    werknemerswoonplaats: employerStatementFormFields.werknemerswoonplaats.defaultValue,
    werknemersgeboortedatum: employerStatementFormFields.werknemersgeboortedatum.defaultValue,
    werknemersindiensttreding: employerStatementFormFields.werknemersindiensttreding.defaultValue,
    werknemersfunctie: employerStatementFormFields.werknemersfunctie.defaultValue,
    werknemersarbeidsvorm: employerStatementFormFields.werknemersarbeidsvorm.defaultValue,
    werknemersuitdiensttreding: employerStatementFormFields.werknemersuitdiensttreding.defaultValue,
    werknemersflexibelarbeidsvorm:
      employerStatementFormFields.werknemersflexibelarbeidsvorm.defaultValue,
    heeftproeftijd: employerStatementFormFields.heeftproeftijd.defaultValue,
    proeftijdverstreken: employerStatementFormFields.proeftijdverstreken.defaultValue,
    isDirecteurAandeelhouder: employerStatementFormFields.isDirecteurAandeelhouder.defaultValue,
    dienstverbandbinnenkortbeeindigen:
      employerStatementFormFields.dienstverbandbinnenkortbeeindigen.defaultValue,
    toelichtingDienstverbandBeeindiging:
      employerStatementFormFields.toelichtingDienstverbandBeeindiging.defaultValue,
    percentageAandelen: employerStatementFormFields.percentageAandelen.defaultValue,
    verklaringVoortzettingDienstverband:
      employerStatementFormFields.verklaringVoortzettingDienstverband.defaultValue,
    jaBepaaldeTijd: employerStatementFormFields.jaBepaaldeTijd.defaultValue,
    toelichtingwordenDeArbeidsvoorwaardenGewijzigd:
      employerStatementFormFields.toelichtingwordenDeArbeidsvoorwaardenGewijzigd.defaultValue,
    verklaringvoortzettingdienstverbandnaam:
      employerStatementFormFields.verklaringvoortzettingdienstverbandnaam.defaultValue,
    jaarsalaris: employerStatementFormFields.jaarsalaris.defaultValue,
    vakantieToeslag: employerStatementFormFields.vakantieToeslag.defaultValue,
    onregelmatigheidsToeslag: employerStatementFormFields.onregelmatigheidsToeslag.defaultValue,
    vaste13eMaand: employerStatementFormFields.vaste13eMaand.defaultValue,
    provisie: employerStatementFormFields.provisie.defaultValue,
    eindejaarsUitkering: employerStatementFormFields.eindejaarsUitkering.defaultValue,
    overwerk: employerStatementFormFields.overwerk.defaultValue,
    extraFlexibleBudget: employerStatementFormFields.extraFlexibleBudget.defaultValue,
    incomeCustom1Title: employerStatementFormFields.incomeCustom1Title.defaultValue,
    incomeCustom1Amount: employerStatementFormFields.incomeCustom1Amount.defaultValue,
    incomeCustom2Title: employerStatementFormFields.incomeCustom2Title.defaultValue,
    incomeCustom2Amount: employerStatementFormFields.incomeCustom2Amount.defaultValue,
    heeftOnderhandseLening: employerStatementFormFields.heeftOnderhandseLening.defaultValue,
    ingangsdatumOnderhandseLening:
      employerStatementFormFields.ingangsdatumOnderhandseLening.defaultValue,
    hoofdsomOnderhandseLening: employerStatementFormFields.hoofdsomOnderhandseLening.defaultValue,
    jaarlastOnderhandseLening: employerStatementFormFields.jaarlastOnderhandseLening.defaultValue,
    looptijdOnderhandseLening: employerStatementFormFields.looptijdOnderhandseLening.defaultValue,
    heeftLoonbeslag: employerStatementFormFields.heeftLoonbeslag.defaultValue,
    einddatumLoonbeslag: employerStatementFormFields.einddatumLoonbeslag.defaultValue,
    maandlastPerMaandLoonbeslag:
      employerStatementFormFields.maandlastPerMaandLoonbeslag.defaultValue,
    naamOndertekenaar: employerStatementFormFields.naamOndertekenaar.defaultValue,
    getekendTe: employerStatementFormFields.getekendTe.defaultValue,
    datumOndertekening: employerStatementFormFields.datumOndertekening.defaultValue,
    naamContactpersoon: employerStatementFormFields.naamContactpersoon.defaultValue,
    telefoonnummerContactpersoon:
      employerStatementFormFields.telefoonnummerContactpersoon.defaultValue,
    wordenDeArbeidsvoorwaardenGewijzigd:
      employerStatementFormFields.wordenDeArbeidsvoorwaardenGewijzigd.defaultValue
  };
};

export { prepareFormData, getDefaultValues };
